import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import BetterAuthProvider from 'context/BetterAuthProvider';
import { BrowserRouter } from 'react-router-dom';
import {
  MantineProvider,
  localStorageColorSchemeManager,
  v8CssVariablesResolver,
} from '@mantine/core';
import {
  emotionTransform,
  MantineEmotionProvider,
  Global,
} from '@mantine/emotion';
import { DatesProvider } from '@mantine/dates';
import { appTheme, getGlobalStyle } from 'styles/theme';
import { FIRST_DAY_OF_WEEK } from 'helpers/dateUtils';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
// Must come after core and dates styles.
import '@mantine/schedule/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/tiptap/styles.css';
import 'mantine-datatable/styles.css';
import './i18n';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import isYesterday from 'dayjs/plugin/isYesterday';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(isYesterday);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);

const colorSchemeManager = localStorageColorSchemeManager({
  key: 'color-scheme',
});

const Main = () => {
  return (
    <React.StrictMode>
      <MantineProvider
        theme={appTheme}
        stylesTransform={emotionTransform}
        defaultColorScheme="light"
        colorSchemeManager={colorSchemeManager}
        cssVariablesResolver={v8CssVariablesResolver}>
        {/* Mantine defaults every calendar and date picker to a Monday-first
            week; this is the one place that flips the whole app to Sunday. */}
        <DatesProvider settings={{ firstDayOfWeek: FIRST_DAY_OF_WEEK }}>
          <MantineEmotionProvider>
            <Global styles={getGlobalStyle} />
            <Notifications position="top-center" />
            <BrowserRouter>
              <BetterAuthProvider>
                <App />
              </BetterAuthProvider>
            </BrowserRouter>
          </MantineEmotionProvider>
        </DatesProvider>
      </MantineProvider>
    </React.StrictMode>
  );
};
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Main />
);
